// extracted by mini-css-extract-plugin
export default {"author":"Authors_author__s2LVE"};